<template>
    <div v-if="content" class="container">
        <div class="row">
            <div class="col-4 logo">
                <img src="/images/logo_2.jpg" alt="Ifero 2.0" class="d-inline-block align-text-top" />
            </div>
            <div class="col-4 header-text">
                <div>
                    {{ seller.name }}<br />
                    {{ seller.addr }}<br />
                    Tel: {{ seller.tel }}
                </div>
            </div>
            <div class="col-4 header-text">
                <div>
                    PIB: {{ seller.pib }}<br />
                    Matični broj: {{ seller.mb }}<br />
                    Tekući račun: {{ seller.tr2 }}<br />
                </div>
            </div>
        </div>
        <div class="row p-5">
            <div class="col small text-center">
                <h1>OVLAŠĆENJE</h1>
            </div>
        </div>
        <div class="row">
            <div class="col small">
                {{ seller.name }}, {{ seller.addr }} MB: {{ seller.mb }} ovlašćuje fizičko lice:
            </div>
        </div>
        <div class="row pt-4">
            <div class="col-3 small ">
                Ovlašćenik: <br />
                JMBG ovlašćenika: <br />
                Adresa ovlašćenika: <br />
                Br. lične karte ovlašćenika:
            </div>
            <div class="col-9 small fw-bold">
                {{ content.authorized ? content.authorized.full_name : '' }}<br />
                {{ content.authorized ? content.authorized.jmbg : '' }}<br />
                {{ content.authorized ? content.authorized.address : '' }}<br />
                {{ content.authorized ? content.authorized.lk_num : '' }}
            </div>
        </div>
        <div class="row pt-4">
            <div class="col small">
                da može u naše ime izvršiti odjavu registracije, ponovnu registraciju vozila, produženje registracije,
                predati
                dokumentaciju za duplikat nalepnice, duplikat saobraćajne dozvole, zamenu registarskih tablica i
                saobraćajne dozvole, promenu imaoca vozila, preuzeti saobraćajnu dozvolu, duplikat nalepnice, nove
                registarske tablice, odjaviti vozilo, prijaviti nestanak reg. tablica, podnese dokumentaciju za
                izdavanje
                uverenja, potvrda o odjavi vozila i preuzme isto, kao i ostale radnje u nadležnom MUP-u za dole navedeno
                vozilo:
            </div>
        </div>

        <div class="row pt-4 border-bottom pb-4">
            <div class="col-3 small">
                Marka vozila:<br />
                Tip vozila:<br />
                Broj šasije:<br />
                Reg. Broj:<br />
            </div>
            <div class="col-9 small fw-bold">
                {{ content.brand }}<br />
                {{ content.model }}<br />
                {{ content.chassis_nr }}<br />
                {{ content.registration_nr }}<br />
            </div>
        </div>

        <div class="row pt-5 mt-5">
            <div class="col-5 small">
                U Beogradu,<br />
                {{ dateFormat(content.createdAt) }}. god.
            </div>
            <div class="col-1 small text-center">
                M.P.
            </div>
            <div class="col-5 small text-center">
                {{ seller.name }}<br />
                <div style="border-bottom: 1px solid black; margin: 40px 20px 5px 20px;"></div>
                {{ currentUser.firstname }} {{ currentUser.lastname }}
            </div>
        </div>

    </div>
</template>

<script>
import dateUtils from "../../utils/date-common";
import utils from "../../utils/common";

export default {
    name: "authorization-report",
    props: ["content"],
    methods: {
        dateFormat(date) {
            return dateUtils.formatDate(date);
        },
        numFormat(num) {
            return utils.toNumberFormat(num);
        },
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        seller() {
            return this.$store.state.app.seller;
        },
    },
};
</script>

<style scoped>
.container {
    /* border: 1px solid gray; */
    width: 800px;
    height: 900px;
}

.container .row>.col,
.container .row>[class^="col-"] {
    /* padding-top: 0.75rem;
  padding-bottom: 0.75rem; */
    /* background-color: rgba(39, 41, 43, 0.03); */
    /* border: 1px solid rgba(39, 41, 43, 0.1); */
}

.logo {
    padding: 0 !important;
}

img {
    width: 240px;
}

.header-text {
    font-size: 11px;
}
</style>
